<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マーク掲載順設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">グループ</label>
            <div class="list-input-content">
              <select id="cmb_MarkGroup" #cmb_MarkGroup [style.width.px]="'180'" [tabindex]="0"
                [(ngModel)]="kymw1505Model.selectedMarkGroup" (change)="eventMarkGroupName_CHANGEHandler()">
                <ng-template ngFor let-item [ngForOf]="kymw1505Model.markGroupList">
                  <option value="{{item.MarkGroupCode}}">{{item.Caption}}</option>
                </ng-template>
              </select>
            </div>
          </div>

          <wj-flex-grid #dtg_MarkList id="dtg_MarkList" [itemsSource]="kymw1505Model.displayMarkList"
            [headersVisibility]="'All'" [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'Rows'"
            (draggingRow)="onDraggingRow(dtg_MarkList, $event)" (draggedRow)="onDraggedRow(dtg_MarkList, $event)"
            horizontalScrollPolicy="on" verticalScrollPolicy="on" [autoScroll]="true">
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク\nコード'" [width]="80" [binding]="'markCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク名'" [width]="320" [binding]="'markName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'マーク画像'" [width]="325" [binding]="'markFileUrl'" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [style.text-align]="'center'">
                  <img src="{{cell.item.markFileUrl}}" class="cell-image">
                </div>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_setting" class="btn-primary" (click)="eventSetting_CLICKHandler()"
            forcedEnabledMode="none" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
